module.exports = __webpack_public_path__ + "img/warning-icon.df6bcc74.svg";